import PatcraftApi from "../../../scripts/patcraft-api";

// Initial state
const state = () => ({
  openedFilter: {},
  isFilterOptionsOpened: false,
  isImageInfoOpened: false,
  imgPreviewOpened: false,
  filterOptionsCount: 10,
  selectedFilterCount: 8,
  openedImage: JSON.parse(localStorage.getItem('imageData')),
  pageNumber: 1,
  pageSize: 15,
  totalPages: 0,
  totalCount: null,
  isFetching: false,
  images: [],
  isPdp: false
});

// Getters
const getters = {
  openedFilter: state => {
    return state.openedFilter;
  },
  isFilterOptionsOpened: state => {
    return state.isFilterOptionsOpened;
  },
  isImageInfoOpened: state => {
    return state.isImageInfoOpened;
  },
  filterOptionsCount: state => {
    return state.filterOptionsCount;
  },
  selectedFilterCount: state => {
    return state.selectedFilterCount;
  },
  imgPreviewOpened: state => {
    return state.imgPreviewOpened;
  },
  openedImage: state => {
    return state.openedImage;
  },
  pageNumber: state => {
    return state.pageNumber;
  },
  pageSize: state => {
    return state.pageSize;
  },
  isFetching: state => {
    return state.isFetching;
  },
  images: state => {
    return state.images;
  },
  showLoadMore: state => {
    return (
      state.totalPages > state.pageNumber ||
      (state.isFetching && state.images.length === 0)
    );
  },
  totalCount: state => {
    return state.totalCount;
  },
  isPdp: state => {
    return state.isPdp;
  }
};

// Actions
const actions = {
  setOpenedFilter({ commit }, filter) {
    commit("setOpenedFilter", { filter });
  },
  setIsFilterOptionsOpened({ commit }, value) {
    commit("setIsFilterOptionsOpened", { value });
  },
  setIsImageInfoOpened({ commit }, value) {
    commit("setIsImageInfoOpened", { value });
  },
  setFilterOptionsCount({ commit }, count) {
    commit("setFilterOptionsCount", { count });
  },
  setSelectedFilterCount({ commit }, count) {
    commit("setSelectedFilterCount", { count });
  },
  setImgPreviewOpened({ commit }, value) {
    commit("setImgPreviewOpened", { value });
  },
  setOpenedImage({ commit }, image) {
    commit("setOpenedImage", { image });
  },
  changePreviewImage({ commit }, value) {
    commit("changePreviewImage", { value });
  },
  setPageNumber({ commit }, page) {
    commit("setPageNumber", { page });
  },
  setResults({ commit }, results) {
    commit("setResults", { results });
  },
  setTotalCount({ commit }, count) {
    commit("setTotalCount", { count });
  },
  setIsFetching({ commit }, value) {
    commit("setIsFetching", { value });
  },
  fetchResults({ commit, state, dispatch }, data) {
    if (state.isFetching) {
      return;
    }
    dispatch("setIsFetching", true);
    if (state.pageNumber === 1) {
      dispatch("setResults", []);
    }
    PatcraftApi.getInspirationImages(data)
      .then(res => {
        commit("setResults", { results: [...res.data.items] });
        commit("setTotalPages", { pages: res.data.totalPages });
        commit("setTotalCount", { count: res.data.totalCount });
        dispatch("setIsFetching", false);
        const newOpenedFilter =
          res.data.assetFilters.find(
            f => f.azureFilterName === state.openedFilter.azureFilterName
          ) ?? {};
        dispatch("setOpenedFilter", newOpenedFilter);
        dispatch(
          "filters/updateFilterOptions",
          { filters: [...res.data.assetFilters] },
          { root: true }
        );
        if (state.imgPreviewOpened) {
          dispatch("setOpenedImage", res.data.items[0]);
        }
      })
      .catch(error => {
        dispatch("setIsFetching", false);
      });
  },
  updateTranding({ commit }, data) {
    PatcraftApi.updateInspirationTranding(data);
  },
  updateIsPdp({ commit }, value) {
    commit("setIsPdp", { value });
  }
};

// Mutations
const mutations = {
  setIsPdp(state, { value }) {
    state.isPdp = value;
  },
  setOpenedFilter(state, { filter }) {
    state.openedFilter = filter;
  },
  setIsFilterOptionsOpened(state, { value }) {
    state.isFilterOptionsOpened = value;
  },
  setIsImageInfoOpened(state, { value }) {
    state.isImageInfoOpened = value;
  },
  setFilterOptionsCount(state, { count }) {
    state.filterOptionsCount = count;
  },
  setSelectedFilterCount(state, { count }) {
    state.selectedFilterCount = count;
  },
  setImgPreviewOpened(state, { value }) {
    state.imgPreviewOpened = value;
  },
  setOpenedImage(state, { image }) {
    state.openedImage = image?image:JSON.parse(localStorage.getItem('imageData'));
  },
  changePreviewImage(state, { value }) {
    const lastIndex = state.images.length - 1;
    const currIndex = state.images.findIndex(
      img => img.embedId === state.openedImage.embedId
    );
    let newIndex = currIndex + value;
    if (newIndex < 0) newIndex = 0;
    if (newIndex > lastIndex) {
      if (state.pageNumber < state.totalPages) {
        this.dispatch("inspirationPage/setPageNumber", state.pageNumber + 1);
      }
      return;
    }
    this.dispatch("inspirationPage/setOpenedImage", state.images[newIndex]);
  },
  setPageNumber(state, { page }) {
    state.pageNumber = page;
  },
  setResults(state, { results }) {
    if (state.pageNumber > 1) {
      state.images = [...state.images, ...results];
    } else {
      if (state.isPdp) {
        state.images = [...results.slice(0, 6)];
      } else {
        state.images = [...results];
      }
    }
  },
  setIsFetching(state, { value }) {
    state.isFetching = value;
  },
  setTotalPages(state, { pages }) {
    state.totalPages = pages;
  },
  setTotalCount(state, { count }) {
    state.totalCount = count;
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
